import classNames from 'classnames';
import { Fragment } from 'react';
import { toast } from 'react-toastify';
import { List } from 'yoso';
import { BaseCard } from '~/components/Card';
import { currencySymbol } from '~/components/Currency/Currency.hooks';
import { Don } from '~/components/Don/Don';
import { useRewardHistory } from '~/components/Don/History/DonHistory.hooks';
import { T, t } from '~/components/I18n';
import { DescriptionList } from '~/components/List/Description/DescriptionList';
import { Popup, PopupProps } from '~/components/Modal/Popup/Popup';
import { regularFormat } from '~/components/Util';
import { format, formatBoost } from '~/components/Util/number';
import styles from './DonHistoryRewardPopup.module.scss';

export type DonHistoryRewardPopupProps = Omit<PopupProps, 'id'> & {
  id: number;
};

export const DonHistoryRewardPopup = ({ id, ...props }: DonHistoryRewardPopupProps) => {
  const {
    data: {
      totalAmount,
      purchaseAmount,
      purchaseCurrency,
      rewardAmount,
      rewardAt,
      rewardDetailList,
    },
    error,
  } = useRewardHistory(id, { useErrorBoundary: false });

  if (error) {
    props?.onDismiss?.();
    toast(t('citizen_error_500_toast'));
  }

  return (
    <Popup
      {...props}
      className={styles.root}
      title={
        <>
          {format(totalAmount)} DON
          <small className={styles.date}>{regularFormat(rewardAt, 'PP p')}</small>
        </>
      }
      description={<T name="citizen_don_history_popup_desc1" />}
      // data-event="impression"
      // data-event-category="purchase_reward_details_popup"
    >
      <BaseCard className={styles.body} shadow>
        <DescriptionList layout="horizontal" className={styles.receipt}>
          <dt>
            {currencySymbol[purchaseCurrency]} {format(purchaseAmount)}
          </dt>
          <dd
            className={classNames({
              [styles.inactive]: rewardAmount === 0,
            })}>
            <Don value={rewardAmount} />
          </dd>
          {rewardDetailList.map(({ level, itemType, count, amount, boost }, index) => (
            <Fragment key={index}>
              <dt>
                {itemType === 'CITIZEN' ? `Lv. ${level}` : 'Friends'} (x
                {itemType === 'CITIZEN' && count > 20 ? '20+' : count})
              </dt>
              <dd className={classNames({ [styles.inactive]: amount === 0 })}>
                {formatBoost(boost)}%
              </dd>
            </Fragment>
          ))}
        </DescriptionList>
      </BaseCard>
      <div className={styles.footer}>
        <List className={styles.disclaimerList} type="bullet">
          <li>
            <T name="citizen_don_history_popup_desc3" />
          </li>
        </List>
      </div>
    </Popup>
  );
};
